import React, { useEffect }  from "react"
import { Passage }           from "./passage"
import { FontAwesomeIcon }   from "@fortawesome/react-fontawesome"
import { skipWeekends }      from "@react/helpers/helpers"
import { TYPES }             from "../app"

export const DatePlanned = ({
  workorderState,
  setWorkorderState,
  maximumDuration,
  autoNumbered = true
}) => {
  const addPassages = number => {
    const copiedPassages = [...workorderState.passages]
    
    for (let i = 0; i < number; i++) {
      let previousPassage = copiedPassages[copiedPassages.length - 1]

      const newDatePlanned = new Date(previousPassage ? previousPassage.datePlanned : workorderState.datePlanned)
      newDatePlanned.setDate(newDatePlanned.getDate() + 1)
      skipWeekends(newDatePlanned)

      copiedPassages.push({
        datePlanned:  newDatePlanned.toISOString(),
        includeExtra: true,
        predictedDuration: workorderState.predictedDuration,
        technicianId: workorderState.technicianId
      })
    }
    setWorkorderState({ passages: copiedPassages })
  }

  const changePassageDate = (date, index) => {
    const copiedPassages  = [...workorderState.passages]
    const selectedDatePlanned = index === null ? workorderState.datePlanned : copiedPassages[index].datePlanned 
    const interval = date - new Date(selectedDatePlanned)
    const passagesToUpdate = copiedPassages.filter(({datePlanned}) => new Date(datePlanned) >= new Date(selectedDatePlanned))

    passagesToUpdate.map(passage => passage.datePlanned = new Date(new Date(passage.datePlanned).getTime() + interval).toISOString())
    if (index === null) {
      setWorkorderState({ passages: copiedPassages, datePlanned: new Date(date).toISOString() })
    } else {
      setWorkorderState({ passages: copiedPassages })
    }
  }

  const changePassageDuration = (duration, index) => {
    const passageDuration = duration > maximumDuration ? maximumDuration : duration
    if (index === null) {
      setWorkorderState({ predictedDuration: passageDuration })
    } else {
      const copiedPassages  = [...workorderState.passages]
      const passageToChange = copiedPassages[index]
      passageToChange.predictedDuration = passageDuration
      setWorkorderState({ passages: copiedPassages })
    }
  }

  const removePassage = index => {
    const copiedPassages = [...workorderState.passages]
    copiedPassages.splice(index, 1)
    setWorkorderState({ passages: copiedPassages })
  }

  useEffect(() => {
    const copiedPassages = [...workorderState.passages]
    copiedPassages.map((passage) => {
      passage['technicianId'] = workorderState.technicianId
    })
    setWorkorderState({ passages: copiedPassages })
  }, [workorderState.technicianId])

  const showNumbers   = autoNumbered || workorderState.passages.length > 0
  const gridStyle     = showNumbers ? undefined : { gridTemplateColumns: '5fr 2fr' }

  const canAddPassages = workorderState.technicianId && workorderState.workorderType !== TYPES.preventive

  const addButtons = (
    <>
      { canAddPassages && workorderState.passages.length <= 20 &&
        <div className = "flex-end">
          <a className = "small mr-2 text-pointer" onClick = { () => addPassages(1) }>
            <FontAwesomeIcon icon="plus-circle" className = "mr-2" />
            { I18n.t("workorders.add_one_passage") }
          </a>
        </div>
      }
      { canAddPassages && workorderState.passages.length <= 15 &&
        <div className = "flex-end">
          <a className = "small mr-2 text-pointer" onClick = { () => addPassages(5) }>
            <FontAwesomeIcon icon="plus-circle" className = "mr-2" />
            { I18n.t("workorders.add_five_passages") }
          </a>
        </div>
      }
    </>
  )

  return (
    <>
      <div className = "date-and-duration" style = { gridStyle }>
        { showNumbers && <div></div> }
        <label className = "control-label" htmlFor = "workorder_date_planned">
          { I18n.t("workorders.due_date") }
        </label>
        <label className = "control-label"
               htmlFor   = "workorder_predicted_duration"
        >
          { I18n.t("workorders.duration_in_min") }
        </label>
      </div>
      <div className = "flexbox-space-between p-relative date-and-duration" style = { gridStyle }>
        <Passage
          index                   = { null }
          datePlanned             = { new Date(workorderState.datePlanned).toISOString() }
          predictedDuration       = { workorderState.predictedDuration }
          changePassageDate       = { changePassageDate }
          changePassageDuration   = { changePassageDuration }
          showPassageNumber       = { showNumbers }
        />
      </div>
      { workorderState.workorderType !== TYPES.preventive &&
        <>
          {
            workorderState.passages.map((pass, index) => {
              return (
                <div
                  className = "flexbox-space-between p-relative date-and-duration"
                  key       = { index }
                >
                  <Passage
                    index                   = { index }
                    datePlanned             = { pass.datePlanned }
                    predictedDuration       = { pass.predictedDuration }
                    changePassageDate       = { changePassageDate }
                    changePassageDuration   = { changePassageDuration }
                    removePassage           = { removePassage }
                    minDate                 = { new Date(workorderState.datePlanned) }
                  />
                </div>
              )
          })}
          { addButtons }
        </>
      }
    </>
  )
}